// app/javascript/src/klaro_config.js
export const klaroConfig = {
    version: 1,
    elementID: 'klaro', // Das muss im HTML (Layout) vorhanden sein!
    storageMethod: 'cookie',
    cookieName: 'klaro',
    mustConsent: false,
    noNotice: false,
    acceptAll: true,
    callback: function (consent: any, service: any) {
        console.log('Klaro callback for service:', service.name, 'consent:', consent);
        if (service.name === 'youtube' && consent === true) {
            // Trigger ein Event oder nutze den globalen Dispatcher falls nötig,
            // aber wir nutzen hier am besten den Manager Watcher.
        }
    },
    translations: {
        de: {
            privacyPolicy: {
                name: "Datenschutzerklärung",
                text: "Weiteres findest du in der Datenschutzerklärung."},
            privacyPolicyUrl: '/de/pages/2-datenschutzerklarung',
            consentNotice: {
                description: 'Juraclimbs verwendet technisch notwendige Cookies um Dienste bereitzustellen. Wenn du externe Medien wie z.B. YouTube Videos auf Juraclimbs nutzen möchtest, benötigen wir deine Zustimmung. Hier kannst du einsehen und anpassen, welche Information wir über dich sammeln.',
                learnMore: 'Auswahl zeigen',
            },
            consentModal: {
                title: 'Cookie-Einstellungen',
                description:
                    'Hier kannst du bestimmen, welche Informationen JuraClimbs oder externe Dienste über dich speichern dürfen.',
            },
            ok: 'Alle akzeptieren',
            decline: 'Alle ablehnen',
            youtube: {
                description: 'Videos von YouTube anzeigen.',
            },
            purposes: {
                marketing: {
                    title: 'Marketing & Tracking',
                    description: 'Diese Cookies werden von YouTube verwendet, um Werbung für dich relevant zu gestalten.'
                },
            },
        },
        en: {
            privacyPolicyUrl: '/en/pages/2-datenschutzerklarung',
            consentNotice: {
                description: 'Juraclimbs uses cookies that are technically necessary to provide its services. If you wish to use external media, such as YouTube videos, on Juraclimbs, we require your consent. Here you can view and adjust the information we collect about you.',
            },
            consentModal: {
                title: 'Cookie-Settings',
                description: 'Here you can view and update the information we collect about you.',
            },
            youtube: {
                description: 'Watch videos from YouTube.',
            },
            purposes: {
                marketing: {
                    title: 'Marketing & Tracking',
                    description: 'These cookies are used by YouTube to tailor adverts to your interests.'
                },
            },
        },
    },
    services: [
        {
            name: 'youtube',
            title: 'YouTube',
            purposes: ['marketing'],
            default: false,
            required: false
        }
    ]
};
